import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Trip2ThemeModule } from '../../../trip2-theme/trip2-theme.module';
import { GoogleMapsModule } from '../google-maps/google-maps.module';
import { MapPinAdjustmentComponent } from './map-pin-adjustment.component';

@NgModule({
  imports: [CommonModule, Trip2ThemeModule, GoogleMapsModule],
  declarations: [MapPinAdjustmentComponent],
  exports: [MapPinAdjustmentComponent],
  providers: []
})
export class MapPinAdjustmentModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-pin-adjustment/map-pin-adjustment.module.ts